import type { DriveItem } from '@/mocks/driveFiles';

interface BulkDeleteDialogProps {
  items: DriveItem[];
  onConfirm: () => void;
  onCancel: () => void;
}

export default function BulkDeleteDialog({ items, onConfirm, onCancel }: BulkDeleteDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onCancel}>
      <div className="bg-background-50 rounded-xl p-6 max-w-sm w-full border border-background-200 animate-in fade-in zoom-in-95 duration-150" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 mb-4">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 flex-shrink-0">
            <i className="ri-alert-line text-xl text-accent-500"></i>
          </span>
          <div><h3 className="text-base font-semibold text-foreground-900">여러 항목 삭제</h3></div>
        </div>
        <div className="mb-3 max-h-[160px] overflow-y-auto space-y-1.5">
          {items.map((item) => (
            <div key={item.id} className="flex items-center gap-2.5 px-3 py-1.5 bg-background-100 rounded-lg border border-background-200">
              <span className={`w-6 h-6 flex items-center justify-center rounded-md flex-shrink-0 ${item.type === 'folder' ? 'bg-accent-50' : 'bg-background-200'}`}>
                <i className={`${item.type === 'folder' ? 'ri-folder-3-fill text-accent-500' : 'ri-file-3-line text-foreground-600'} text-xs`}></i>
              </span>
              <span className="text-sm text-foreground-800 truncate">{item.name}</span>
            </div>
          ))}
        </div>
        <p className="text-sm text-foreground-600 mb-5">선택한 {items.length}개 항목을 삭제하시겠습니까? 폴더의 경우 포함된 모든 내용이 함께 삭제됩니다.</p>
        <div className="flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 text-sm font-medium rounded-lg border border-background-300 text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">취소</button>
          <button onClick={onConfirm} className="px-4 py-2 text-sm font-medium rounded-lg bg-accent-500 text-white hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap">{items.length}개 삭제</button>
        </div>
      </div>
    </div>
  );
}